import { render, staticRenderFns } from "./CurrentVehicleValuationComponent.vue?vue&type=template&id=a05d2da8"
import script from "./CurrentVehicleValuationComponent.vue?vue&type=script&lang=ts"
export * from "./CurrentVehicleValuationComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports